module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoBdOl.f7849051.otf";